import ReactGA from "react-ga";
import Cookies from "js-cookie";
import voucherCodeCache from "../utils/voucherCodeCache";
import {
  COOKIE_CROSS_DOMAIN,
  COOKIE_PROFILE,
  COOKIE_CHOCOMEMBER_ID,
  COOKIE_ACCESS_TOKEN,
  COOKIE_REFRESH_TOKEN,
  COOKIE_ANNOUNCEMENT_ID,
  COOKIE_LAST_SIGNIN_PROVIDER,
} from "../../constants/cookie";

import { IS_DEV } from "../../constants/env";

import { CAMPAIGN_POINTS_STEP } from "../reducers/ui/campaignStep";
import {
  CAMPAIGN_POINTS_SOURCE,
  CAMPAIGN_EVENT6,
} from "../reducers/ui/campaignSource";

const auth = {
  getClientId() {
    return new Promise((resolve, reject) => {
      const timer = setTimeout(() => {
        console.warn("get GA clientId readyCallback timeout");
        resolve("not-found");
      }, 5000);

      ReactGA.ga((tracker) => {
        clearTimeout(timer);

        const clientId = tracker?.get?.("clientId");
        resolve(clientId);
      });
    });
  },

  loggedIn() {
    return Boolean(Cookies.get(COOKIE_ACCESS_TOKEN));
  },

  logout() {
    Cookies.remove(COOKIE_PROFILE);
    Cookies.remove(COOKIE_CHOCOMEMBER_ID, { domain: COOKIE_CROSS_DOMAIN });
    Cookies.remove(COOKIE_ACCESS_TOKEN, { domain: COOKIE_CROSS_DOMAIN });
    Cookies.remove(COOKIE_REFRESH_TOKEN, { domain: COOKIE_CROSS_DOMAIN });

    // for IndexAnnouncement (Jira CT-4464)
    Cookies.remove(COOKIE_ANNOUNCEMENT_ID);

    // 會員養成
    window?.localStorage?.removeItem(CAMPAIGN_POINTS_STEP);
    window?.localStorage?.removeItem(CAMPAIGN_POINTS_SOURCE);
    window?.localStorage?.removeItem(CAMPAIGN_EVENT6);

    // 清除序號暫存
    voucherCodeCache.remove();
  },

  setToken(accessToken, refreshToken) {
    Cookies.set(COOKIE_ACCESS_TOKEN, accessToken, {
      expires: 60,
      secure: !IS_DEV,
      sameSite: "lax",
      domain: COOKIE_CROSS_DOMAIN,
    });

    Cookies.set(COOKIE_REFRESH_TOKEN, refreshToken, {
      expires: 60,
      secure: !IS_DEV,
      sameSite: "lax",
      domain: COOKIE_CROSS_DOMAIN,
    });
  },

  setProfile(profile) {
    const in30Minutes = 1 / 48;
    Cookies.set(COOKIE_PROFILE, profile, {
      expires: in30Minutes,
      secure: !IS_DEV,
      sameSite: "lax",
    });
  },

  setChocomemberId(chocomemberId) {
    Cookies.set(COOKIE_CHOCOMEMBER_ID, chocomemberId, {
      expires: 60,
      secure: !IS_DEV,
      sameSite: "lax",
      domain: COOKIE_CROSS_DOMAIN,
    });
  },

  getChocomemberId() {
    return Cookies.get(COOKIE_CHOCOMEMBER_ID);
  },

  getProfile() {
    return Cookies.getJSON(COOKIE_PROFILE);
  },

  delProfile() {
    Cookies.remove(COOKIE_PROFILE);
  },

  getAccessToken() {
    return Cookies.get(COOKIE_ACCESS_TOKEN);
  },

  getRefreshToken() {
    return Cookies.get(COOKIE_REFRESH_TOKEN);
  },

  rememberLastSigninProvider(provider) {
    Cookies.set(COOKIE_LAST_SIGNIN_PROVIDER, provider, {
      expires: 365,
    });
  },
};

export default auth;
